import { NopCollector_instance2gq24j1mymjl3 as NopCollector_instance } from './internal/NopCollector.mjs';
import { ensureActive17z6c489wymmv as ensureActive } from './Emitters.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *collect(_this__u8e3s4, $completion) {
  return yield* _this__u8e3s4.z1c(NopCollector_instance, $completion);
}
function *emitAll(_this__u8e3s4, flow, $completion) {
  ensureActive(_this__u8e3s4);
  yield* flow.z1c(_this__u8e3s4, $completion);
  return Unit_instance;
}
//region block: exports
export {
  collect as collect2p01yx803enkx,
  emitAll as emitAllc6188g3y1sqz,
};
//endregion

//# sourceMappingURL=Collect.mjs.map
